export default __webpack_public_path__ + "static/media/idd.a7fb411f.png";